import apiHandler from "./apiHandler";

const apiSubscriptions = {
  billing: () => {
    return new Promise((resolve, reject) => {
      apiHandler
        .get(`/stripe/billing-portal`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  pilotCheckout: (name, state) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .get(`/stripe/pilot-checkout`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  airlineCheckout: (name, state) => {
    return new Promise((resolve, reject) => {
      apiHandler
        .get(`/stripe/airline-checkout`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export default apiSubscriptions;
